import { StudentAdditionalPanelComponent } from './student-additional-panel/student-additional-panel.component';
import { StudentMusicPanelComponent } from './student-music-panel/student-music-panel.component';
import { StudentSportsPanelComponent } from './student-sports-panel/student-sports-panel.component';
import { StudentRotcPanelComponent } from './student-rotc-panel/student-rotc-panel.component';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';

import { StudentActivitiesPanelComponent } from './student-activities-panel/student-activities-panel.component';
import { Component, Input, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-student-social-card',
  templateUrl: './student-social-card.component.html',
  styleUrls: ['./student-social-card.component.scss']
})
export class StudentSocialCardComponent implements OnInit, OnDestroy {
  @ViewChild('activitiesCard') activitiesCard: StudentActivitiesPanelComponent;
  @ViewChild('rotcCard') rotcCard: StudentRotcPanelComponent;
  @ViewChild('sportsCard') sportsCard: StudentSportsPanelComponent;
  @ViewChild('musicCard') musicCard: StudentMusicPanelComponent;
  @ViewChild('additionalCard') additionalCard: StudentAdditionalPanelComponent;

  @Input() profileData: any;
  formsTouched = false;
  subscription: Subscription;
  constructor(private commonDataSharedService: CommonDataSharedService) {

  }
  ngOnInit() {
    this.subscription = this.commonDataSharedService.saveProfile.subscribe(() => {
      if (this.activitiesCard.activitiesTouched || this.rotcCard.rotcFormTouched || this.sportsCard.sportFormsTouched || this.musicCard.musicFormsTouched || this.additionalCard.additionalFormsTouched) {
        this.commonDataSharedService.socialSaveProfile.next(true);
      } else {
        this.commonDataSharedService.socialSaveProfile.next(false);
      }

    })
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
